var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox table-box" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page" },
        [
          _c("oaFromBox", {
            attrs: {
              isViewSearch: false,
              title: _vm.$route.meta.title,
              total: _vm.total,
              btnText: "添加类目",
            },
            on: { addDataFn: _vm.addFinance },
          }),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "mt10",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tree-props": { children: "children" },
                "default-expand-all": "",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "类目名称", "min-width": "220", prop: "name" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("toptable.sort"),
                  "min-width": "100",
                  prop: "sort",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("public.operation"),
                  prop: "address",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["fd:setup:category:edit"],
                                expression: "['fd:setup:category:edit']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.edit")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["fd:setup:category:delete"],
                                expression: "['fd:setup:category:delete']",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteFn(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("public.delete")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "paginationClass" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.where.page,
                  "page-size": _vm.where.limit,
                  "page-sizes": [10, 15, 20],
                  total: _vm.total,
                  layout: "total, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.where, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.where, "page", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.where, "limit", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.where, "limit", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("dialog-form", {
        ref: "repeatDialog",
        attrs: { "repeat-data": _vm.repeatData },
        on: {
          isOk: function ($event) {
            return _vm.invoiceCategoryList()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }